import {currentPerson, currentProfile, usePerson, usePrincipal, useProfile} from "@betrue/front/services";
import {useEffect, useState} from "react";
import {StringParam, useQueryParam} from "use-query-params";
import {AnnotatedSubject, BaseEntity, Person, Profile} from "@betrue/shared/interfaces";
import {ReactiveVar} from "@apollo/client/cache/inmemory/reactiveVars";
import {useReactiveVar} from "@apollo/client";

export const subjectView = (): BaseEntity => {
  const [subjectId, ] = useQueryParam('subjectId', StringParam);
  const [subjectModel, ] = useQueryParam('subject', StringParam);
  const [person,] = usePerson<Person>(currentPerson)
  const [subject, setSubject] = useState<BaseEntity>(null)
  useEffect(() => {
    if (subjectId && subjectModel) {
      switch (subjectModel) {
        case AnnotatedSubject.PersonModel:
          console.log('subject',person)
         if(person){
           setSubject(person)
         }
         break;
      }
    }

  }, [person])

  return subject
}

export const useViewV2 = <T extends BaseEntity>(store: ReactiveVar<T>, o: T,
                                                getter: (id?: string) => any):
  [
    T, (subject: T) => void,
    string,
    string,
    (arg: string) => void,
    (arg: string) => void,] => {
  const [subjectId, setSubjectId] = useQueryParam('subjectId', StringParam);
  const [subjectModel, setSubjectModel] = useQueryParam('subject', StringParam);
  const [principal] = usePrincipal()
  const subject = useReactiveVar(store)

  useEffect(() => {
    if (!subject) {
      if (subjectId) {
        getter(subjectId)
      }
    }
  }, [subjectId, principal, subject])


  useEffect(() => {
    if (o) {
      store(o)
      setSubjectId(o.id)
      setSubjectModel(o.__typename)
    }
  }, [o])

  const setSubject = (o) => {
    store(o)
  }

  return [subject, setSubject, subjectId, subjectModel, setSubjectId, setSubjectModel]
}

export const usePersonView = (): [person: Person, profile: Profile] => {
  const [principal] = usePrincipal()
  const [person, {updatePerson, getPersonById}] = usePerson<Person>(currentPerson)
  const [viewPerson, setSubject, subjectId, subjectModel, setSubjectId, setSubjectModel] = useViewV2(currentPerson, person, getPersonById)
  const [viewProfile, {getProfileById}] = useProfile<Profile>(currentProfile)

  useEffect(() => {
    if (!subjectId && !subjectModel && principal) {
      setSubjectId(principal.id)
      setSubjectModel(principal.__typename)
      getProfileById(principal.profile.id)
      setSubject(principal)
    }
  }, [principal])


  useEffect(() => {
    if (viewPerson && !viewProfile && subjectId) {
      getProfileById(viewPerson.profile.id)
    }
  }, [viewPerson, subjectId])


  return [viewPerson, viewProfile]
}


